import React, { useEffect, useState } from "react";
import {
  formatDate,
  getClientsRawData,
  lessThanNetRiskPayoutAmt,
  lessThannetRiskPayoutAmt,
  onlyNumberEnter,
  onlyNumberUpTo100,
} from "../../CommonMethhods/CommonMethods";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm, useFieldArray } from "react-hook-form";
import RoundLoader from "../../Components/Common/RoundRingLoader";

function PayoutBrokerage(props) {
  const dataBrokerage = props.rmsData || [];
  // const dummYTrueFalse = false;
  const PayOutSchema = Yup.object().shape({
    ApPayout: Yup.array().of(
      Yup.object().shape({
        apId: Yup.string().required(),
        apCode: Yup.string().required(),
        apName: Yup.string().required(),
        module: Yup.string().required(),
        sapCode: Yup.string().required(),
        periodFrom: Yup.string().required(),
        periodTo: Yup.string().required(),
        pan: Yup.string().required(),
        gstNo: Yup.string().required(),
        actualGrossBrokerage: Yup.string().required(),
        grossBrokerage: Yup.string().required(),
        apSharing: Yup.string().required(),
        netBrokerage: Yup.string().required(),
        gst18Perc: Yup.string().required(),
        totalInvoice: Yup.string().required(),
        tds5Perc: Yup.string().required(),
        apLedger: Yup.string().required(),
        apRisk: Yup.string().required(),
        airtelCharges: Yup.string().required(),
        depositToBeAdjusted: Yup.string().required(),
        depositAmt: Yup.string().required(),
        apAMC: Yup.string().required(),
        otherDeductionFR: Yup.string().required(),
        otherDeductionFin: Yup.string().required(),
        finalPayout: Yup.string().required(),
        nseRegistered: Yup.string().required(),
        bseRegistered: Yup.string().required(),
        franchiseeStatus: Yup.string().required(),
        // franchiseeRemarks: Yup.string.required(),
      })
    ),
  });
  const optionsDf = { resolver: yupResolver(PayOutSchema) };
  const {
    control,
    formState,
    handleSubmit,
    register,
    watch,
    reset,
    setValue,
    getValues,
    setError,
    clearErrors,
  } = useForm(optionsDf);
  const { errors } = formState;
  const { fields: payoutField } = useFieldArray({ name: "ApPayout", control });

  useEffect(() => {
    reset({
      ApPayout: dataBrokerage,
    });
  }, [dataBrokerage]);

  const depositToDeductChange = (e, i) => {
    if (e.target.value.length > 0) {
      let netRiskPayoutAmt = getValues(`ApPayout[${i}]netRiskPayoutAmt`);
      let compareValue = Number(netRiskPayoutAmt) - Number(e.target.value);
      if (Math.sign(compareValue) === -1) {
        e.target.style.borderColor = "red";
        setValue(`ApPayout.${i}.netPayout`, 0);
        setError(`ApPayout.${i}.depositToDeduct`, {
          type: "custom",
          message: "value isnt proper",
        });
      } else {
        e.target.style.borderColor = "";
        setValue(`ApPayout.${i}.netPayout`, compareValue.toFixed(2));
        clearErrors(`ApPayout.${i}.depositToDeduct`);
      }
    } else {
      e.target.style.borderColor = "red";
      setValue(`ApPayout.${i}.netPayout`, 0);
      setError(`ApPayout.${i}.depositToDeduct`, {
        type: "custom",
        message: "value isnt proper",
      });
    }
  };
  const depositAmt = (e, i) => {
    if (e.target.value.length > 0) {
      setValue(`ApPayout.${i}.depositAmt`, e.target.value);
      e.target.style.borderColor = "";
    } else {
      e.target.style.borderColor = "red";
      setValue(`ApPayout.${i}.depositAmt`, "");
    }
  };

  const onApprove = (status) => {
    let individualTrue = document.querySelectorAll(".activeData");
    let getValue = getValues();
    let SubmitArray = [];
    for (let data of individualTrue) {
      if (data.checked) {
        let payout = getValues(`ApPayout[${data.value}]`);

        let payoutData = {
          apId: payout.apId || 0,
          apCode: payout.apCode || "",
          apName: payout.apName || "",
          periodFrom: payout.periodFrom || "",
          periodTo: payout.periodTo || "",
          actualGrossBrokerage: payout.actualGrossBrokerage || 0,
          grossBrokerage: payout.grossBrokerage || 0,
          netBrokerage: payout.netBrokerage || 0,
          gsT18Perc: payout.gst18Perc || 0,
          totalInvoice: payout.totalInvoice || 0,
          tdS5Perc: payout.tds5Perc || 0,
          apLedger: payout.apLedger || 0,
          apRisk: payout.apRisk || 0,
          airtelCharges: payout.airtelCharges || 0,
          depositToBeAdjusted: payout.depositToBeAdjusted || 0,
          depositAmt: payout.depositAmt || 0,
          apamc: payout.apAMC || 0,
          otherDeductionFR: payout.otherDeductionFR || 0,
          otherDeductionFin: payout.otherDeductionFin || 0,
          finalPayout: payout.finalPayout || 0,
          franchiseeStatus: status || "",
          franchiseeRemarks: payout.franchiseeRemarks || "",
        };
        SubmitArray.push(payoutData);
      }
    }
    return SubmitArray;
  };

  const onFormState = () => {
    return formState.isValid;
  };

  const handleDownload = (typeFile, apCode) => {
    props.downloadOnClick(typeFile, apCode);
  };

  props.getFormData.onApprove = onApprove;
  props.getFormData.onFormState = onFormState;

  const selectAllChange = (e) => {
    let individualTrue = document.querySelectorAll(".activeData");
    for (let data of individualTrue) {
      data.checked = e.target.checked;
    }
  };

  const singleInputChange = (e) => {
    if (e.target.checked) {
      let AllCheck = [];
      let individualTrue = document.querySelectorAll(".activeData");
      for (let data of individualTrue) {
        AllCheck.push(data.checked);
      }
      if (AllCheck.includes(false)) {
        document.getElementById("select-all-payout").checked = false;
      } else {
        document.getElementById("select-all-payout").checked = true;
      }
    } else {
      document.getElementById("select-all-payout").checked = e.target.checked;
    }
  };

  return (
    <>
      <div className="tableHead">
        <button
          className="downloadBtnPayout1"
          onClick={() => getClientsRawData()}
        >
          Raw Download
        </button>
        <button
          className="downloadBtnPayout"
          onClick={() => handleDownload("excel", "")}
        >
          {props.downloadLoader ? (
             <div className="download-loader">
             <RoundLoader h={"10"} />
           </div>
          ) :(
            "Download"
          )}
        </button>
      </div>
      <div className="ap_master_table scroll-table payout-brokerage-wrapper">
        <table className="table ">
          <thead>
            <tr>
              <th colSpan={35}>Brokerage</th>
            </tr>
            <tr>
              <th scope="col">
                <input
                  className=""
                  type="checkbox"
                  id="select-all-payout"
                  onChange={(e) => selectAllChange(e)}
                />
              </th>
              <th scope="col">AP Code</th>
              <th scope="col">SAP Code</th>
              <th scope="col" className="">
                AP Name
              </th>
              <th scope="col">Period From</th>
              <th scope="col">Period To</th>
              <th scope="col">Module</th>
              <th scope="col">Pan No</th>
              <th scope="col">GST No</th>
              <th scope="col">Actual Gross Brokerage</th>
              <th scope="col">Gross Brokerage</th>
              <th scope="col">AP Sharing %</th>
              <th scope="col">Net Brokerage</th>
              <th scope="col">GST 18%</th>
              <th scope="col">Total Invoice</th>
              <th scope="col">TDS 5%</th>
              <th scope="col">AP Ledger</th>
              <th scope="col">AP Risk</th>
              <th scope="col">Airtel Charges</th>
              <th scope="col">Deposit to be Adjusted</th>
              <th scope="col">Deposit Amount</th>
              <th scope="col">AP AMC</th>
              <th scope="col">Other Deductions FR</th>
              <th scope="col">Other Deductions Fin</th>
              <th scope="col">Final Payout</th>
              <th scope="col">NSE Registered</th>
              <th scope="col">BSE Registered</th>
              <th scope="col">Franchisee Team Approval Status</th>
              <th scope="col">Franchisee Team Remarks</th>
              <th scope="col">RMS Team Approval Status</th>
              <th scope="col">RMS Team Remarks</th>
              <th scope="col">Finance Team Approval Status</th>
              <th scope="col">Finance Team Remarks</th>
              <th scope="col">Banking Team Approval Status</th>
              <th scope="col">Banking Team Remarks</th>

              {/* <th scope="col">Download</th> */}
            </tr>
          </thead>
          <tbody>
            {payoutField.map((item, i) => (
              <>
                <tr key={i}>              

                  <td>
                    <input
                      className={`form-check-input ${
                        getValues(`ApPayout.${i}.franchiseeStatus`) === "Pending"
                        || 
                        (getValues(`ApPayout.${i}.franchiseeStatus`) === "Approved" && 
                        getValues(`ApPayout.${i}.rmsStatus`) === "Rejected")
                        || 
                        (getValues(`ApPayout.${i}.franchiseeStatus`) === "Approved"
                        && getValues(`ApPayout.${i}.rmsStatus`) === "Approved" 
                        && getValues(`ApPayout.${i}.financeStatus`) === "Rejected")
                        ||
                        (getValues(`ApPayout.${i}.franchiseeStatus`) === "Approved"
                        && getValues(`ApPayout.${i}.rmsStatus`) === "Approved" 
                        && getValues(`ApPayout.${i}.financeStatus`) === "Approved"
                        && getValues(`ApPayout.${i}.bankingStatus`) === "Rejected")
                          ? "activeData"
                          : "inActive"
                      }`}
                      defaultChecked={
                        // getValues(`ApPayout.${i}.franchiseeStatus`) !== "Pending"
                        // || 
                        (getValues(`ApPayout.${i}.franchiseeStatus`) === "Approved" && 
                        getValues(`ApPayout.${i}.rmsStatus`) !== "Rejected" &&
                        getValues(`ApPayout.${i}.financeStatus`) !== "Rejected" &&
                        getValues(`ApPayout.${i}.bankingStatus`) !== "Rejected")
                        || 
                        (getValues(`ApPayout.${i}.franchiseeStatus`) === "Approved"
                        && getValues(`ApPayout.${i}.rmsStatus`) === "Approved" 
                        && getValues(`ApPayout.${i}.financeStatus`) !== "Rejected"
                        && getValues(`ApPayout.${i}.bankingStatus`) !== "Rejected")
                        ||
                        (getValues(`ApPayout.${i}.franchiseeStatus`) === "Approved"
                        && getValues(`ApPayout.${i}.rmsStatus`) === "Approved" 
                        && getValues(`ApPayout.${i}.financeStatus`) === "Approved"
                        && getValues(`ApPayout.${i}.bankingStatus`) !== "Rejected")
                      }
                      disabled={
                        // getValues(`ApPayout.${i}.franchiseeStatus`) !== "Pending"
                        // || 
                        (getValues(`ApPayout.${i}.franchiseeStatus`) === "Approved" && 
                        getValues(`ApPayout.${i}.rmsStatus`) !== "Rejected" &&
                        getValues(`ApPayout.${i}.financeStatus`) !== "Rejected" &&
                        getValues(`ApPayout.${i}.bankingStatus`) !== "Rejected")
                        || 
                        (getValues(`ApPayout.${i}.franchiseeStatus`) === "Approved"
                        && getValues(`ApPayout.${i}.rmsStatus`) === "Approved" 
                        && getValues(`ApPayout.${i}.financeStatus`) !== "Rejected"
                        && getValues(`ApPayout.${i}.bankingStatus`) !== "Rejected")
                        ||
                        (getValues(`ApPayout.${i}.franchiseeStatus`) === "Approved"
                        && getValues(`ApPayout.${i}.rmsStatus`) === "Approved" 
                        && getValues(`ApPayout.${i}.financeStatus`) === "Approved"
                        && getValues(`ApPayout.${i}.bankingStatus`) !== "Rejected")
                      }
                      type="checkbox"
                      value={i}
                      onChange={(e) => singleInputChange(e)}
                    />
                  </td>
                  <td>
                    <input
                      className="plane-input"
                      readOnly
                      {...register(`ApPayout.${i}.apCode`)}
                    />
                  </td>

                  <td>
                    <input
                      className="plane-input"
                      readOnly
                      {...register(`ApPayout.${i}.sapCode`)}
                    />
                  </td>
                  <td>
                    {/* <div className="checkbox-wrapper"> */}

                    <input
                      className="plane-input"
                      readOnly
                      {...register(`ApPayout.${i}.apName`)}
                    />
                    {/* </div> */}
                  </td>

                  <td>
                    <input
                      className="plane-input"
                      readOnly
                      value={getValues(`ApPayout.${i}.periodFrom`) ? formatDate(getValues(`ApPayout.${i}.periodFrom`)?.split(" ")[0]) : " "}
                      // {...register(`ApPayout.${i}.periodFrom`)}
                    />
                  </td>
                  <td>
                    <input
                      className="plane-input"
                      readOnly
                      value={getValues(`ApPayout.${i}.periodTo`) ? formatDate(getValues(`ApPayout.${i}.periodTo`)?.split(" ")[0]) : " "}
                      // {...register(`ApPayout.${i}.periodTo`)}
                    />
                  </td>
                  <td>
                    <input
                      className="plane-input"
                      readOnly
                      {...register(`ApPayout.${i}.module`)}
                    />
                  </td>
                  <td>
                    <input
                      className="plane-input"
                      readOnly
                      {...register(`ApPayout.${i}.pan`)}
                    />
                  </td>
                  <td>
                    <input
                      className="plane-input"
                      readOnly
                      {...register(`ApPayout.${i}.gstNo`)}
                    />
                  </td>
                  <td>
                    <input
                      className="plane-input"
                      readOnly
                      {...register(`ApPayout.${i}.actualGrossBrokerage`)}
                    />
                  </td>
                  <td>
                    <input
                      className="plane-input"
                      readOnly
                      {...register(`ApPayout.${i}.grossBrokerage`)}
                    />
                  </td>
                  <td>
                    <input
                      className="plane-input"
                      readOnly
                      {...register(`ApPayout.${i}.apSharing`)}
                    />
                  </td>
                  <td>
                    <input
                      className="plane-input"
                      readOnly
                      {...register(`ApPayout.${i}.netBrokerage`)}
                    />
                  </td>
                  <td>
                    <input
                      className="plane-input"
                      readOnly
                      {...register(`ApPayout.${i}.gst18Perc`)}
                    />
                  </td>
                  <td>
                    <input
                      className="plane-input"
                      readOnly
                      {...register(`ApPayout.${i}.totalInvoice`)}
                    />
                  </td>
                  <td>
                    <input
                      className="plane-input"
                      readOnly
                      {...register(`ApPayout.${i}.tds5Perc`)}
                    />
                  </td>
                  <td>
                    <input
                      className="plane-input"
                      readOnly
                      {...register(`ApPayout.${i}.apLedger`)}
                    />
                  </td>
                  <td>
                    <input
                      className="plane-input"
                      readOnly
                      {...register(`ApPayout.${i}.apRisk`)}
                    />
                  </td>
                  <td>
                    <input
                      className="onChange-field"
                      defaultValue={getValues(
                        `ApPayout.${i}.airtelCharges`
                      )}
                      min={1}
                      max={1000000}
                      type="number"
                      {...register(`ApPayout.${i}.airtelCharges`)}
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/^\s+/, "");
                        if (parseInt(e.target.value) < 1) {
                          e.target.value = 1;
                        } else if (parseInt(e.target.value) > 1000000) {
                          e.target.value = 1000000;
                        }
                      }}
                      
                      disabled={
                        (getValues(`ApPayout.${i}.franchiseeStatus`) === "Approved" && 
                        getValues(`ApPayout.${i}.rmsStatus`) !== "Rejected" &&
                        getValues(`ApPayout.${i}.financeStatus`) !== "Rejected" &&
                        getValues(`ApPayout.${i}.bankingStatus`) !== "Rejected")
                        || 
                        (getValues(`ApPayout.${i}.franchiseeStatus`) === "Approved"
                        && getValues(`ApPayout.${i}.rmsStatus`) === "Approved" 
                        && getValues(`ApPayout.${i}.financeStatus`) !== "Rejected"
                        && getValues(`ApPayout.${i}.bankingStatus`) !== "Rejected")
                        ||
                        (getValues(`ApPayout.${i}.franchiseeStatus`) === "Approved"
                        && getValues(`ApPayout.${i}.rmsStatus`) === "Approved" 
                        && getValues(`ApPayout.${i}.financeStatus`) === "Approved"
                        && getValues(`ApPayout.${i}.bankingStatus`) !== "Rejected")
                      }
                    />
                  </td>
                  <td>
                    <input
                      className="onChange-field"
                      defaultValue={getValues(
                        `ApPayout.${i}.depositToBeAdjusted`
                      )}
                      min={1}
                      max={1000000}
                      type="number"
                      {...register(`ApPayout.${i}.depositToBeAdjusted`)}
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/^\s+/, "");
                        if (parseInt(e.target.value) < 1) {
                          e.target.value = 1;
                        } else if (parseInt(e.target.value) > 1000000) {
                          e.target.value = 1000000;
                        }
                      }}
                      disabled={
                        (getValues(`ApPayout.${i}.franchiseeStatus`) === "Approved" && 
                        getValues(`ApPayout.${i}.rmsStatus`) !== "Rejected" &&
                        getValues(`ApPayout.${i}.financeStatus`) !== "Rejected" &&
                        getValues(`ApPayout.${i}.bankingStatus`) !== "Rejected")
                        || 
                        (getValues(`ApPayout.${i}.franchiseeStatus`) === "Approved"
                        && getValues(`ApPayout.${i}.rmsStatus`) === "Approved" 
                        && getValues(`ApPayout.${i}.financeStatus`) !== "Rejected"
                        && getValues(`ApPayout.${i}.bankingStatus`) !== "Rejected")
                        ||
                        (getValues(`ApPayout.${i}.franchiseeStatus`) === "Approved"
                        && getValues(`ApPayout.${i}.rmsStatus`) === "Approved" 
                        && getValues(`ApPayout.${i}.financeStatus`) === "Approved"
                        && getValues(`ApPayout.${i}.bankingStatus`) !== "Rejected")
                      }
                    />
                  </td>
                  <td>
                    <input
                      className="plane-input"
                      readOnly
                      {...register(`ApPayout.${i}.depositAmt`)}
                    />
                  </td>
                  <td>
                    <input
                      className="onChange-field"
                      defaultValue={getValues(
                        `ApPayout.${i}.apAMC`
                      )}
                      type="number"
                      {...register(`ApPayout.${i}.apAMC`)}
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/^\s+/, "");
                      }}
                      disabled={
                        (getValues(`ApPayout.${i}.franchiseeStatus`) === "Approved" && 
                        getValues(`ApPayout.${i}.rmsStatus`) !== "Rejected" &&
                        getValues(`ApPayout.${i}.financeStatus`) !== "Rejected" &&
                        getValues(`ApPayout.${i}.bankingStatus`) !== "Rejected")
                        || 
                        (getValues(`ApPayout.${i}.franchiseeStatus`) === "Approved"
                        && getValues(`ApPayout.${i}.rmsStatus`) === "Approved" 
                        && getValues(`ApPayout.${i}.financeStatus`) !== "Rejected"
                        && getValues(`ApPayout.${i}.bankingStatus`) !== "Rejected")
                        ||
                        (getValues(`ApPayout.${i}.franchiseeStatus`) === "Approved"
                        && getValues(`ApPayout.${i}.rmsStatus`) === "Approved" 
                        && getValues(`ApPayout.${i}.financeStatus`) === "Approved"
                        && getValues(`ApPayout.${i}.bankingStatus`) !== "Rejected")
                      }
                    />
                  </td>
                  <td>
                    <input
                      className="onChange-field"
                      defaultValue={getValues(
                        `ApPayout.${i}.otherDeductionFR`
                      )}
                      type="number"
                      {...register(`ApPayout.${i}.otherDeductionFR`)}
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/^\s+/, "");
                        
                      }}
                      disabled={
                        (getValues(`ApPayout.${i}.franchiseeStatus`) === "Approved" && 
                        getValues(`ApPayout.${i}.rmsStatus`) !== "Rejected" &&
                        getValues(`ApPayout.${i}.financeStatus`) !== "Rejected" &&
                        getValues(`ApPayout.${i}.bankingStatus`) !== "Rejected")
                        || 
                        (getValues(`ApPayout.${i}.franchiseeStatus`) === "Approved"
                        && getValues(`ApPayout.${i}.rmsStatus`) === "Approved" 
                        && getValues(`ApPayout.${i}.financeStatus`) !== "Rejected"
                        && getValues(`ApPayout.${i}.bankingStatus`) !== "Rejected")
                        ||
                        (getValues(`ApPayout.${i}.franchiseeStatus`) === "Approved"
                        && getValues(`ApPayout.${i}.rmsStatus`) === "Approved" 
                        && getValues(`ApPayout.${i}.financeStatus`) === "Approved"
                        && getValues(`ApPayout.${i}.bankingStatus`) !== "Rejected")
                      }
                    />
                  </td>
                  <td>
                    <input
                      className="plane-input"
                      readOnly
                      {...register(`ApPayout.${i}.otherDeductionFin`)}
                    />
                  </td>
                  <td>
                    <input
                      className="plane-input"
                      readOnly
                      {...register(`ApPayout.${i}.finalPayout`)}
                    />
                  </td>
                  <td>
                    <input
                      className="plane-input"
                      readOnly
                      {...register(`ApPayout.${i}.nseRegistered`)}
                    />
                  </td>
                  <td>
                    <input
                      className="plane-input"
                      readOnly
                      {...register(`ApPayout.${i}.bseRegistered`)}
                    />
                  </td>
                  <td>
                    <input
                      className="plane-input"
                      readOnly
                      {...register(`ApPayout.${i}.franchiseeStatus`)}
                    />
                  </td>
                  <td>
                    <input
                      className="onChange-field"
                      defaultValue={getValues(
                        `ApPayout.${i}.franchiseeRemarks`
                      )}
                      {...register(`ApPayout.${i}.franchiseeRemarks`)}
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/^\s+/, "");
                      }}
                      disabled={
                        (getValues(`ApPayout.${i}.franchiseeStatus`) === "Approved" && 
                        getValues(`ApPayout.${i}.rmsStatus`) !== "Rejected" &&
                        getValues(`ApPayout.${i}.financeStatus`) !== "Rejected" &&
                        getValues(`ApPayout.${i}.bankingStatus`) !== "Rejected")
                        || 
                        (getValues(`ApPayout.${i}.franchiseeStatus`) === "Approved"
                        && getValues(`ApPayout.${i}.rmsStatus`) === "Approved" 
                        && getValues(`ApPayout.${i}.financeStatus`) !== "Rejected"
                        && getValues(`ApPayout.${i}.bankingStatus`) !== "Rejected")
                        ||
                        (getValues(`ApPayout.${i}.franchiseeStatus`) === "Approved"
                        && getValues(`ApPayout.${i}.rmsStatus`) === "Approved" 
                        && getValues(`ApPayout.${i}.financeStatus`) === "Approved"
                        && getValues(`ApPayout.${i}.bankingStatus`) !== "Rejected")
                      }
                      // onInput={(e) => onlyNumberUpTo100(e)}
                    />
                  </td>

                  <td>
                    <input
                      className="plane-input"
                      readOnly
                      {...register(`ApPayout.${i}.rmsStatus`)}
                    />
                  </td>
                  <td>
                    <input
                      className="plane-input"
                      readOnly
                      {...register(`ApPayout.${i}.rmsRemarks`)}
                    />
                  </td>

                  <td>
                    <input
                      className="plane-input"
                      readOnly
                      {...register(`ApPayout.${i}.financeStatus`)}
                    />
                  </td>
                  <td>
                    <input
                      className="plane-input"
                      readOnly
                      {...register(`ApPayout.${i}.financeRemarks`)}
                    />
                  </td>
                  <td>
                    <input
                      className="plane-input"
                      readOnly
                      {...register(`ApPayout.${i}.bankingStatus`)}
                    />
                  </td>
                  <td>
                    <input
                      className="plane-input"
                      readOnly
                      {...register(`ApPayout.${i}.bankingRemarks`)}
                    />
                  </td>

                  {/* <td>
                    <input
                      className="onChange-field"
                      type="text"
                      readOnly={getValues(`ApPayout.${i}.apApproved`)}
                      {...register(`ApPayout.${i}.depositToDeduct`, {
                        onChange: (e) => depositToDeductChange(e, i),
                      })}
                      onInput={(e) =>
                        lessThanNetRiskPayoutAmt(e, item.netRiskPayoutAmt)
                      }
                    />
                  </td> */}
                </tr>
              </>
            ))}
          </tbody>
        </table>
      </div>
      <h4>Total No Of Records : {dataBrokerage.length}</h4>
    </>
  );
}

export default PayoutBrokerage;
